/**
 * Enum for mapping actual Template IDs in the code to the Table IDs in OWR-2066
 */
export enum ETemplateIdRemap {
  /** Home Page */
  '1.0' = '1.0',

  /** Snow & Weather Home */
  '2.0' = '2.0',

  /** Region Snow Report */
  '2.1.1' = '2.1.1',

  /** Region Cams */
  '2.1.2' = '2.1.2',

  /** Region Open Resorts */
  '2.1.3' = '2.1.3',

  /**
     * In the code, 2.1.5 is shared between three different pages.
     * In the table, they have distinct IDs: 2.1.4, 2.1.5, and 3.1.2.
     */
  '2.1.5-region-openings' = '2.1.4',

  '2.1.5-region-closings' = '2.1.5',

  '2.1.5-region-lodging' = '3.1.2',

  /** Region Lift Tickets (Real 2.1.6 -> Table 3.1.3) */
  '2.1.6' = '3.1.3',

  /** Resort Ski Report (Table: Resort Snow Report) */
  '2.2.1' = '2.2.1',

  /** Resort Weather */
  '2.2.2' = '2.2.2',

  /** Resort Cams */
  '2.2.3' = '2.2.3',

  /** Resort Ski Report (FHRs) */
  '2.2.4' = '2.2.4',

  /** Guide Home Page */
  '3.0' = '3.0',

  /** Region Guide Page */
  '3.1.1' = '3.1.1',

  /** Resort Overview -> Resort Guide (Real 3.2.1 -> Table 3.2.1.1) */
  '3.2.1' = '3.2.1.1',

  /** Resort Reviews */
  '3.2.2' = '3.2.2',

  /** Resort Trailmap (Table: Resort Trail Map) */
  '3.2.3' = '3.2.3',

  /** Resort Historical Snowfall */
  '3.2.5' = '3.2.5',

  /** Resort Lift Tickets */
  '3.2.6' = '3.2.6',
}
